import $ from 'jquery';

$( '.js-offcanvas-toggle' ).on( 'click', function() {
	$( 'html' ).toggleClass( 'u-overflow-hidden' );
	$( '.c-offcanvas' ).toggleClass( 'is-active' );
} );
